
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/combat/[goalSlug]/[goalUID]",
      function () {
        return require("private-next-pages/combat/[goalSlug]/[goalUID].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/combat/[goalSlug]/[goalUID]"])
      });
    }
  